/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  path {
    &.fill-1 {
      fill: ${theme.color.matchTit1};
    }
    &.fill-3 {
      fill: ${theme.color.modalyellow};
    }
  }
`
export default class SendHeartIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" css={Color}>
        <g id="그룹_5875" data-name="그룹 5875" transform="translate(-5643 4883)">
          <rect id="사각형_4881" data-name="사각형 4881" width="34" height="34" transform="translate(5643 -4883)" fill="red" opacity="0"/>
          <path id="빼기_3" className="fill-1" data-name="빼기 3"
                d="M9.139,16.425c-.042,0-.09-.009-.1-.029C7.759,15.358,2.62,9.97,2.569,9.915,2.543,9.893,0,7.61,0,4.751V4.723A4.627,4.627,0,0,1,4.53.01c.1-.007.2-.01.3-.01A4.375,4.375,0,0,1,9.013,3.157l.008.021c.02.055.043.117.1.117s.084-.068.1-.122l.006-.015A4.353,4.353,0,0,1,13.4,0c.1,0,.207,0,.31.011h.028a4.637,4.637,0,0,1,4.131,2.8,2.444,2.444,0,0,0-.209.194,2.369,2.369,0,0,0-.642,1.348H16.1a2.289,2.289,0,0,0-2.287,2.287V9.86a2.291,2.291,0,0,0,.506,1.433c-1.533,1.611-4.232,4.415-5.077,5.1C9.228,16.416,9.181,16.425,9.139,16.425Zm6.67-6.686v-3.1a.287.287,0,0,1,.287-.287h1.888A8.644,8.644,0,0,1,15.81,9.738Z"
                transform="translate(5648 -4874)" fill="#294c72" stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1"/>
          <path id="빼기_4" className="fill-3" data-name="빼기 4" d="M5.583,9.96h0a.385.385,0,0,1-.273-.113.378.378,0,0,1-.115-.271v-1.7H2.287A.287.287,0,0,1,2,7.589V4.373a.287.287,0,0,1,.287-.287H5.193v-1.7A.378.378,0,0,1,5.3,2.12.385.385,0,0,1,5.572,2a.363.363,0,0,1,.047,0,.325.325,0,0,1,.232.112L9.61,5.7,9.6,5.692l.025.022a.388.388,0,0,1-.014.549L5.851,9.852A.38.38,0,0,1,5.583,9.96Z" transform="translate(5661.809 -4871.729)" fill="#ea8902" stroke="rgba(0,0,0,0)" strokeMiterlimit="10"
                strokeWidth="1"/>
        </g>
      </svg>

    )
  }
}
